jQuery(document).ready(function($) {
    $('body')
        .on(
            'change',
            '[name="cancellation_insurance"]',
            onToggleCancellationInsurance,
        );

    async function onToggleCancellationInsurance(e) {
        e.stopPropagation();

        try {
            await fetch('/?wc-ajax=toggle-cancellation-insurance');
        } catch (ex) {
            console.error(ex);
        }

        document.body.dispatchEvent(new Event('update_checkout'));
    }
});

//# sourceMappingURL=checkout.js.map
